import React from "react";
export const AddPeopleIcon = () => (
  <svg
    width="20"
    height="12"
    viewBox="0 0 20 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="5.5" cy="3.5" r="3.5" fill="#896300" />
    <path
      d="M-2.66843e-09 11.939C-2.38742e-07 6.53821 11 6.81821 11 12L-2.66843e-09 11.939Z"
      fill="#896300"
    />
    <rect x="15" y="2" width="2" height="8" fill="#896300" />
    <rect
      x="20"
      y="5"
      width="2"
      height="8"
      transform="rotate(90 20 5)"
      fill="#896300"
    />
  </svg>
);
